<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    :class="className"
    :width="width"
    :height="height"
    viewBox="0 0 20 20"
    fill="none"
  >
    <path
      d="M4 6.625V5.5C4 4.67157 4.67157 4 5.5 4H15.25C16.0784 4 16.75 4.67157 16.75 5.5V13.75C16.75 14.5784 16.0784 15.25 15.25 15.25H11.875"
      class="stroke-current"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M13.75 7V12.25"
      class="stroke-current"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M10.75 9.25V12.25"
      class="stroke-current"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M7.5625 10.375C7.5625 11.0999 6.97487 11.6875 6.25 11.6875C5.52513 11.6875 4.9375 11.0999 4.9375 10.375C4.9375 9.65013 5.52513 9.0625 6.25 9.0625C6.97487 9.0625 7.5625 9.65013 7.5625 10.375Z"
      class="stroke-current"
      stroke-width="1.5"
      stroke-linecap="round"
    />
    <path
      d="M6.24924 13.75C5.36785 13.75 4.57524 14.1301 4.02637 14.7353C3.53253 15.2798 4.05986 16 4.79497 16H7.7035C8.43862 16 8.96598 15.2798 8.47211 14.7353C7.92324 14.1301 7.13063 13.75 6.24924 13.75Z"
      class="stroke-current"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>

<script>
export default {
  name: 'CreativeAnalyticsIcon',
  props: {
    width: {
      type: Number,
      default: 20
    },
    height: {
      type: Number,
      default: 20
    },
    className: {
      type: String,
      default: ''
    }
  }
}
</script>
